import {
  Accordion,
  AccordionDetails,
  AppBar,
  Button,
  Stack,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { EventMetadata, MeasurementMetadata } from "../shared/interfaces/Data";
import { HistoricMeasurementDateDropdown } from "./HistoricMeasurementDateDropdown";

interface Props {
  historicMetadataList: (MeasurementMetadata | EventMetadata)[] | undefined;
  selectedMetadata: MeasurementMetadata | EventMetadata | undefined;
  onSelectedHistoricMetadataChange: (selectedCaptureId: number | undefined) => void;
  clearSelectedEvents: () => void;
  chartContainerSx?: SxProps<Theme> | undefined;
}

export function HistoricMeasurementViewer(props: React.PropsWithChildren<Props>) {
  const { t } = useTranslation();
  const theme = useTheme();

  const { historicMetadataList, selectedMetadata, onSelectedHistoricMetadataChange } = props;

  if (historicMetadataList && historicMetadataList?.length > 0)
    return (
      <>
        <Accordion expanded={Boolean(selectedMetadata)} variant="outlined">
          <AppBar
            position="static"
            variant="elevation"
            elevation={0}
            sx={{
              backgroundColor: theme.palette.lightBackground.main,
              color: theme.palette.secondary.contrastText,
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={2} my={1} ml={2}>
              <Typography>{t("results.viewHistoricMeasurement")}</Typography>
              <HistoricMeasurementDateDropdown
                value={selectedMetadata}
                metadataList={historicMetadataList}
                onChange={onSelectedHistoricMetadataChange}
              />
              <Button
                size="small"
                color="primary"
                onClick={props.clearSelectedEvents}
                hidden={selectedMetadata == null}
              >
                {t("common.clearSelection")}
              </Button>
            </Stack>
          </AppBar>
          <AccordionDetails sx={props.chartContainerSx}>{props.children}</AccordionDetails>
        </Accordion>
      </>
    );
  else return null;
}
